import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-admin-country-add',
  templateUrl: './admin-country-add.component.html'
})
export class AdminCountryAddComponent implements OnInit {
  @Input() formdata;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  form;
  
  constructor(
    private fb: FormBuilder,
    private router: Router) { }

  ngOnInit() {
    this.form = this.fb.group({
      id: [null, ''],
      isoCode: ['', ''],
      name: ['', ''],
      order: ['', '']
    });
  
    this.router.events.subscribe(r => {
      if (r instanceof NavigationEnd) {
        this.form.reset();
      }
    });
  }

  saveCountry() {
    this.doSave.emit(this.form.value);
    this.form.reset();
  }

  cancel() {
    this.doCancel.emit();
  }

}
